//import Layout from '@/parts/layout/Index.vue';
const Layout = () => import('@/parts/layout/Index.vue');
//import Empty from '@/parts/layout/Empty.vue';
const Empty = () => import('@/parts/layout/Empty.vue');

// 默认的路由
const defaultRoutes = reactive([{
	path: '/',
	name: '__home',
	meta: { title: '首页' },
	redirect: '/home',
	component: Layout,
	children: [{
		path: 'home',
		name: '__system-home',
		component: () => import('@/views/Home.vue'),  
		meta: {
			title: '控制面板'
		}
	}, {
		path: 'message',
		name: '__system-message',
		component: Empty,
		redirect: 'list',
		meta: { title: '系统消息' },
		children: [{
			path: 'list',
			name: '__system-message-list',
			component: () => import('@/views/message/List.vue'),
			meta: {
				title: '列表'
			}
		},
		{
			path: 'view-:id(\\d+)',
			name: '__system-message-view',
			component: () => import('@/views/message/View.vue'),
			meta: {
				title: '查看'
			} 
		}]
	}, {
		path: 'profile',
		name: '__system-profile',
		redirect: 'basic',
		component: () => import('@/views/system/Profile.vue'), 
		meta: {
			title: '个人中心'
		},
		children: [
			{
				path: 'basic', 
				name: '__system-profile-basic',
				component: () => import('@/views/system/profile/BasicInfo.vue'), 
				meta: {
					title: '基础资料'
				}
			}, {
				path: 'corp',
				name: '__system-profile-corp',
				component: () => import('@/views/system/profile/CorpInfo.vue'), 
				meta: {
					title: '企业资料'
				}
			}, {
				path: 'notify',
				name: '__system-profile-notify',
				component: () => import('@/views/system/profile/Notify.vue'),
				meta: {
					title: '通知设置'
				}
			}, {
				path: 'changepwd', 
				name: '__system-profile-changepwd',
				component: () => import('@/views/system/profile/ChangePassword.vue'), 
				meta: {
					title: '修改密码'
				}
			}
		]
	}, {
		path: 'settings',
		name: '__system-settings',
		component: () => import('@/views/system/Settings.vue'),  
		meta: {
			title: '设置'
		}
	}, {
		path: 'service',
		name: '__system-service',
		redirect: 'list',
		component: Empty, 
		meta: { title: '增值服务' },
		children: [{
			path: 'list',
			name: '__system-service-list',
			component: () => import('@/views/service/Index.vue'),
			meta: {
				title: '服务列表'
			},
		}, {
			path: 'buyqt',
			name: '__system-service-buy',
			component: () => import('@/views/service/BuyQueryTimes.vue'),
			meta: {
				title: '购买次数'
			},
		}, {
			path: 'result',
			name: '__system-service-buy-result',
			component: () => import('@/views/service/BuyResult.vue'),
			meta: {
				title: '购买结果'
			}
		}]
	}, {// 404 页面路由
		path: '/:pathMatch(.*)*', // 匹配所有路径
		name: '__system-page-not-found',
		meta: { title: '页面不存在' },
		component: () => import('@/parts/layout/NotFound.vue') // 404 页面组件
	}]
}, {
	path: '/login',
	name: '__login',
	component: () => import('@/views/Login.vue'),
	meta: {
		title: '登录'
	}
}]);

export const useDefaultRoutes = () => {
	return defaultRoutes;
}